import React from "react";
import AdminLayout from "./AdminLayout";
import AnalyticsDashboard from "../../components/Admin/AnalyticsDashboard";

const AnalyticsPage = () => {
  return (
    <AdminLayout>
      <AnalyticsDashboard />
    </AdminLayout>
  );
};

export default AnalyticsPage;
